import { render, staticRenderFns } from "./LastOrderedProducts.vue?vue&type=template&id=c5ca367c&scoped=true"
import script from "./LastOrderedProducts.vue?vue&type=script&lang=js"
export * from "./LastOrderedProducts.vue?vue&type=script&lang=js"
import style0 from "./LastOrderedProducts.vue?vue&type=style&index=0&id=c5ca367c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ca367c",
  null
  
)

export default component.exports